// Helper functions for MovieModalV2

/**
 * Convert seconds to "Xh Ym" format
 */
export const secondsToHoursMinutes = (sec: number): string => {
  const hours = Math.floor(sec / (60 * 60));
  // eslint-disable-next-line no-param-reassign
  sec -= hours * (60 * 60);
  const minutes = Math.floor(sec / 60);
  return `${hours}h ${minutes}m`;
};
